<app-loader *ngIf="isLoading"></app-loader>

<div class="container-fluid px-0">
  <div class="row">
    <div class="d-flex col-lg-5 justify-content-start">
      <app-main-heading>
        <span title>{{ "SIDEBAR.LICENSESUMMARY" | translate }}</span>
      </app-main-heading>
    </div>

    <div
      class=" d-flex col-lg-7 cursor-pointer flex flex-wrap align-items-center justify-content-end licenseUserDropDown">
      <ng-select #licenseUser class="bg-transparent custom" [items]="userResponse" bindLabel="name" bindValue="id"
        [clearable]=false [searchable]=false [(ngModel)]="userSelected" (ngModelChange)="onfilterChange($event)">
        <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
          <img height="15" width="15" src="assets/images/Vector 651usericon.svg" />
          <span class="ps-2">{{item?.name.length > 15 ? item?.name.slice(0,15) + "..." : item?.name}}</span>
        </ng-template>
        <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
          <span title={{item?.name}}>{{ item?.name.length> 15 ? item?.name.slice(0,15) + "..." : item?.name}}</span>
        </ng-template>
      </ng-select>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="mng-device-tabs">
        <div id="tabs-profile" role="tabpanel" aria-labelledby="tabs-profile-tab">
          <div class="row bg-white mt-3 mb-5 p-3 justify-content-center text-center rounded-25" style="margin: 0px"
            *ngIf="totalDeviceCount === 0">
            <div class="col-md-12">
              <div class="nodatafounddiv">
                <img [src]="'IMAGES.NORECORDFOUNDIMG'|translate" class="img-fluid" alt="" />
                <h1 class="mt-4">
                  <app-main-heading>
                    <span title>{{
                      "LICENSESUMMARY.NOLICENSEFOUND" | translate
                      }}</span>
                  </app-main-heading>
                </h1>
              </div>
            </div>
          </div>


          <div class="mx-auto w-100 relative d-none d-md-block" *ngIf="getMyUseDeviceData?.length != 0">
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab">
                <div class="d-flex mt-3">
                  <div class="col-3">
                    <nav id="" aria-label="">
                      <div *ngFor="let item of showMyUserDeviceData; let ind = index;"
                        class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
                        <div *ngFor="
                        let myUserDevice of item.myUserLicenseList;let i = index">
                          <ul class="flex-column min-w-100 d-flex list-unstyled me-4 license-summary"
                            id="pills-tabVertical">
                            <!-- <span>
                            <strong>{{ item.name }} ({{
                              item.myUserLicenseList?.length
                              }})</strong>
                          </span> -->
                            <li class="align-items-center justify-content-center  cursor-pointer mt-sm-0 mb-0"
                              role="presentation" (click)="selectedUserIndex(i, myUserDevice)" [ngClass]="
                          selectedUserLicenseId == myUserDevice.id
                            ? 
                              myUserDevice.productKeyType == 'MOBILE'
                              ? 
                                myUserDevice.productKeyType == 'MOBILE'||
                                myUserDevice.productKeyType == 'FAMILY_PACK'||
                                myUserDevice.productKeyType == 'SYSTEM'
                                ? 'q-vertical-text-border'
                                : 'q-vertical-text-license'
                              : 
                                myUserDevice.productKeyType == 'FAMILY_PACK' &&
                                myUserDevice.productLink != null
                              ? 'q-vertical-text-border'
                              : 'q-vertical-text-border'
                            : 'q-vertical-text-license'
                        ">
                              <div class="justify-content-center">
                                <tab-title-inline>
                                  <span title1>
                                    <span *ngIf="myUserDevice?.productKeyType == 'SYSTEM'" style="margin: 0px">
                                      <img src="./assets/images/systemRounded.svg" class="me-2" alt="" srcset=""
                                        height="35px" width="35px" />
                                    </span>
                                    <span *ngIf="myUserDevice?.productKeyType == 'MOBILE'" style="margin: 0px">
                                      <img src="./assets/images/mobileroundicon.png" class="me-2" alt="" srcset=""
                                        height="35px" width="35px" />
                                    </span>
                                  </span>
                                  <span title1 data-toggle="tooltip" i18n-title title='{{myUserDevice?.deviceName == null
                              ? "N/A"
                              : myUserDevice?.deviceName}} ' style="font-size: 16px;" *ngIf="
                                myUserDevice.productKeyType !== 'FAMILY_PACK'
                              ">
                                    {{
                                    myUserDevice?.deviceName == null
                                    ? "N/A" : myUserDevice?.deviceName.length > 20 ?
                                    myUserDevice?.deviceName.slice(0,20)+
                                    "..."
                                    : myUserDevice?.deviceName
                                    }}
                                  </span>
                                  <span title1 data-toggle="tooltip" i18n-title
                                    title='{{"LICENSESUMMARY.MULTIDEVICEKEY" | translate}}' *ngIf="
                                myUserDevice.productKeyType == 'FAMILY_PACK'
                              "><strong>{{
                                      "LICENSESUMMARY.MULTIDEVICEKEY" | translate
                                      }}</strong></span>
                                  <!-- <span title2 data-toggle="tooltip" i18n-title title='{{myUserDevice?.productName == null
                              ? "N/A"
                              : myUserDevice?.productName}}'>{{
                                    myUserDevice?.productName == null
                                    ? "N/A"
                                    : myUserDevice?.productName
                                    }}</span> -->
                                </tab-title-inline>
                                <div class="mt-0">
                                  <div data-toggle="tooltip" i18n-title title='{{
                                                          "LICENSESUMMARY.MULTIDEVICEPACK" | translate
                                                          }}' *ngIf="myUserDevice.productKeyType == 'FAMILY_PACK'">
                                    <img [src]="'LICENSESUMMARY.MULTIDEVICEIMG'|translate" alt="" />
                                    <small class="fw-normal ms-2">{{
                                      "LICENSESUMMARY.MULTIDEVICEPACK" | translate
                                      }}</small>
                                  </div>
                                  <div class="badge text-center ms-5" [style.color]="txt_color"
                                    [style.background-color]="bg_badge_clr"
                                    *ngIf="myUserDevice.expiringStatus === 'LICENSE_EXPIRING_SOON'">
                                    {{ "LICENSESUMMARY.ABOUTTOEXPIRE" | translate }}
                                  </div>

                                  <div class="badge text-center ms-5" [style.color]="txt_color"
                                    [style.background-color]="bg_badge_clr"
                                    *ngIf="myUserDevice.licenseValidityDate == 'Free version'">
                                    {{ "LICENSESUMMARY.BUYPREMIUM" | translate }}
                                  </div>

                                  <div class="badge ms-5 text-xs text-center" [style.background-color]="bg_badge_clr"
                                    [style.color]="txt_color"
                                    *ngIf="myUserDevice.expiringStatus === 'LICENSE_EXPIRED' ">
                                    {{ "MANAGEDEVICE.LICENSEEXP" | translate }}
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </nav>
                  </div>
                  <div class="col-9">
                    <div class="q-vertical-content-license borser-radius-6" *ngIf="totalDeviceCount > 0">
                      <ng-container *ngIf="selectedUserLicenseIndex === 0">
                        <div class="row bg-gray license-exp-rowwidth align-items-center justify-content-center mt-2"
                          style="border-style: solid; border-color: #FFDDDD;border-width: 1px;border-radius: 6px;"
                          *ngIf="getUserIndexData.expiringStatus != null">
                          <div class="license-exp-text mb-2 ms-3"><span class="me-1"><img class="me-1"
                                src="./assets/images/licenseAlert.svg" alt=""></span><span
                              *ngIf="getUserIndexData.expiringStatus === 'LICENSE_EXPIRING_SOON' ">{{"LICENSESUMMARY.ABOUTTOEXPIRE"
                              |
                              translate}}</span><span *ngIf="getUserIndexData.expiringStatus === 'LICENSE_EXPIRED'">{{
                              "MANAGEDEVICE.LICENSEEXP" | translate }}</span><span
                              *ngIf="getUserIndexData.expiringStatus === 'LICENSE_EXPIRING_SOON'"
                              class="exp-duration-text"><span><img class="me-1" src="./assets/images/TimeclockTime.svg"
                                  alt=""></span>{{ "MANAGEDEVICE.EXPIREIN" |
                              translate}}{{" "+getUserIndexData.expirydays+" "}}{{ "MANAGEDEVICE.DAYS" |
                              translate}}</span>
                          </div>
                        </div>

                        <div
                          *ngIf="getUserIndexData?.productKeyType == 'MOBILE' || getUserIndexData?.productKeyType == 'FAMILY_PACK'">

                          <div class="d-flex flex-wrap mt-4">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.NAME" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.name == null
                              ? "N/A"
                              : getUserIndexData?.name
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.EMAIL" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.email == null
                              ? "N/A"
                              : getUserIndexData?.email
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class=" col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.PHONENO" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.phoneNumber == null
                              ? "N/A"
                              : getUserIndexData?.phoneNumber
                              }}
                            </div>
                          </div>



                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.PRODUCTNAME" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.productName == null
                              ? "N/A"
                              : getUserIndexData?.productName
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.PRODUCTKEY" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.productKey == null
                              ? "N/A"
                              : getUserIndexData?.productKey
                              }}
                            </div>
                          </div>



                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.BUILDVERSION" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.buildVersion == null
                              ? "N/A"
                              : getUserIndexData?.buildVersion
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.LICENSEVALIDITY" | translate
                              }}
                            </div>
                            <div class="col-6 q-tab-content-list-desc d-flex align-items-center">
                              {{
                              getUserIndexData?.licenseValidityDate == null
                              ? "N/A"
                              : getUserIndexData?.licenseValidityDate
                              }}

                              <span class="ms-1 cursor-pointer"
                                onclick="getMobileProductKeyDetails(getUserIndexData?.id,'userIndex')">
                                <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                              </span>
                              <span (click)="getMobileProductKeyDetails(getUserIndexData?.id,'userIndex')">
                                <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                  {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                              </span>
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.ACTIVATIONDATE" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.activationDate == null
                              ? "N/A"
                              : getUserIndexData?.activationDate
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.AUTORENEW" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.autoRenewal == 1
                              ? ('LICENSESUMMARY.YES' | translate)
                              : ('LICENSESUMMARY.NO' | translate)
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              <span *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                        getUserIndexData?.productKeyType == 'FAMILY_PACK'
                          ? 'mt-3'
                          : ''
                      ">{{ "LICENSESUMMARY.LICENSEOUNT" | translate }}
                              </span>
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              <span *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                            getUserIndexData?.productKeyType == 'FAMILY_PACK'
                              ? 'mt-3'
                              : ''
                          ">{{
                                getUserIndexData?.totalLicenseCount == null
                                ? "N/A"
                                : getUserIndexData?.totalLicenseCount
                                }}
                                <span class="ms-2" *ngIf="totalNumberOfDevices?.length <= 30">
                                  <span *ngFor="let item of totalNumberOfDevices">
                                    <img [src]="'LICENSESUMMARY.KEYACTIVE'|translate" alt="" *ngIf="item.isSelected">
                                    <img [src]="'LICENSESUMMARY.KEYINACTIVE'|translate" alt="" *ngIf="!item.isSelected">
                                  </span>
                                </span>
                                <span class="ms-2" *ngIf="totalNumberOfDevices?.length > 30">
                                  <span *ngFor="let item of totalNumberOfDevices;let idx=index">
                                    <img [src]="'LICENSESUMMARY.KEYACTIVE'|translate" alt=""
                                      *ngIf="item.isSelected&&idx<30">
                                    <img [src]="'LICENSESUMMARY.KEYINACTIVE'|translate" alt=""
                                      *ngIf="!item.isSelected&&idx<30">
                                    <span *ngIf="idx==30">...</span>
                                  </span>
                                </span>
                              </span>
                            </div>
                          </div>

                          <div class="d-flex mt-4 mb-2"
                            *ngIf="getUserIndexData?.licenseValidityDate !== 'Free version'">

                            <button [disabled]="!getUserIndexData?.productLink" [ngClass]="
      getUserIndexData?.productLink == null
        ? 'q-invalid-button'
        : 'submit-btn bg-orgclr'
    " (click)="checkBeforeRenew(getUserIndexData?.productType)">

                              {{ 'LICENSESUMMARY.RENEW' | translate }}

                            </button>

                          </div>

                          <div class="d-flex mt-4 mb-3">
                            <div class="q-tab-content-title">
                              <div *ngIf="
                            getUserIndexData?.licenseValidityDate === 'Free version'
                          ">
                                <button [disabled]="getUserIndexData?.productLink == null"
                                  [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button me-3' : 'q-form-white-submit cursor-pointer me-3' "
                                  (click)="openMyIndexRenewLicense(getUserIndexData,'PREMIUM')">
                                  {{ "LICENSESUMMARY.BUYPREMIUM" | translate }}
                                </button>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div *ngIf="getUserIndexData?.productKeyType == 'SYSTEM'">

                          <div class="d-flex flex-wrap mt-4">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.PRODUCTNAME" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.productName == null
                              ? "N/A"
                              : getUserIndexData?.productName
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.PRODUCTVERSION" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.buildVersion == null
                              ? "N/A"
                              : getUserIndexData?.buildVersion
                              }}
                            </div>
                          </div>
                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.LICENSEDTO" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.name == null
                              ? "N/A"
                              : getUserIndexData?.name
                              }}
                            </div>
                          </div>
                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.PRODUCTKEY" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.productKey == null
                              ? "N/A"
                              : getUserIndexData?.productKey
                              }}
                            </div>
                          </div>
                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.INSTALLATIONNUMBER" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.installationNo == null
                              ? "N/A"
                              : getUserIndexData?.installationNo
                              }}
                            </div>
                          </div>
                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.LICENSEVALIDTILL" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc d-flex align-items-center">
                              {{
                              getUserIndexData?.licenseValidityDate == null
                              ? "N/A"
                              : getUserIndexData?.licenseValidityDate
                              }}
                              <span class="ms-1 cursor-pointer"
                                onclick="getDesktopProductKeyDetails(getUserIndexData?.productKey,'userIndex')">
                                <img [src]="'DASHBOARD.REFRESHDETAILSSVG' | translate" alt="ref-details" />
                              </span>
                              <span (click)="getDesktopProductKeyDetails(getUserIndexData?.productKey,'userIndex')">
                                <p button="submit" class="refreshScore text-align-left cursor-pointer ms-1">
                                  {{ "DASHBOARD.REFRESHDETAILSCTA" | translate }} </p>
                              </span>
                            </div>
                          </div>
                          <div class="d-flex flex-wrap mt-3">
                            <div class="col-3 q-tab-content-list-title">
                              {{ "LICENSESUMMARY.AUTORENEW" | translate }}
                            </div>
                            <div class="col-4 q-tab-content-list-desc">
                              {{
                              getUserIndexData?.autoRenewal == 1
                              ? "Yes"
                              : "No"
                              }}
                            </div>
                          </div>
                          <div class="d-flex mt-5 mb-2">
                            <div [ngStyle]="{ width: selectedLanguage === 'ja' ? '155px' : '120px' }" *ngIf="
                          getUserIndexData?.licenseValidityDate !== 'Free version'
                        ">
                              <button
                                *ngIf="getUserIndexData?.expirydays < 90 || getUserIndexData?.productName == 'Quick Heal Total Security'"
                                [disabled]="!getUserIndexData?.productLink"
                                [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button' : 'submit-btn bg-orgclr' "
                                (click)="checkBeforeRenew(getUserIndexData?.productType)">
                                {{ 'LICENSESUMMARY.RENEW' | translate }}
                              </button>

                              <button
                                *ngIf="getUserIndexData?.expirydays >= 90  && getUserIndexData?.productName != 'Quick Heal Total Security'"
                                [disabled]="!getUserIndexData?.productLink"
                                [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button' : 'submit-btn bg-orgclr' "
                                (click)="checkBeforeRenew(getUserIndexData?.productType)">
                                {{ 'LICENSESUMMARY.UPGRADE' | translate }}
                              </button>
                            </div>
                            <!-- <div class="ms-3">
                              <button type="button" disabled class="q-form-white-submit bg-white"
                                style="width: 120px; height: 40px; text-wrap: nowrap; padding-left: 18px; padding-right: 18px;">
                                {{ "Auto Renew" | translate }}
                              </button>
                            </div> -->
                          </div>

                          <!-- <div class="d-flex flex-wrap mt-3">
                          <div class="q-tab-content-title">
                            {{ "LICENSESUMMARY.PRODLICENSEDTO" | translate }} :
                          </div>
                          <div class="q-tab-content-desc">
                            {{
                            getUserIndexData?.name == null
                            ? "N/A"
                            : getUserIndexData?.name
                            }}
                          </div>
                        </div>
                        <div class="d-flex flex-wrap mt-3">
                          <div class="q-tab-content-title">
                            {{ "LICENSESUMMARY.LICENSEVALIDITY" | translate }}
                            <span *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                            getUserIndexData?.productKeyType == 'FAMILY_PACK'
                              ? 'mt-3'
                              : ''
                          ">
                              / {{ "LICENSESUMMARY.EXPIRYDATE" | translate }}
                            </span>
                            :
                          </div>
                          <div class="q-tab-content-desc">
                            {{
                            getUserIndexData?.licenseValidityDate == null
                            ? "N/A"
                            : getUserIndexData?.licenseValidityDate
                            }}
                          </div>
                        </div> -->
                        </div>
                        <span title9>
                          <div *ngIf="
                        getUserIndexData?.productKeyType === 'FAMILY_PACK' &&
                        licenseHistoryRecords?.length != 0
                      " class="my-4 w-1000">
                            <div class="table-responsive" id="license-table">
                              <table class="table activity-table mb-0" aria-describedby="License summary">
                                <thead class="activity-header">
                                  <tr>
                                    <th>
                                      {{ "LICENSESUMMARY.DEVICENAME" | translate }}
                                    </th>
                                    <th>
                                      {{ "LICENSESUMMARY.ACTIVATIONDATE" | translate }}
                                    </th>
                                    <th>{{ "LICENSESUMMARY.IMEINO" | translate }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="text-capitalize bg-white" *ngFor="let item of licenseHistoryRecords">
                                    <td>
                                      {{ item.deviceName | translate }}
                                    </td>
                                    <td>
                                      {{ getDate(item.activationDate) }}
                                    </td>
                                    <td>
                                      {{ item.installationNo }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- <div *ngIf="
                        getUserIndexData?.productKeyType == 'SYSTEM' &&
                        licenseHistoryRecords?.length != 0
                      " class="my-4 mw-1000">
                          <hr />
                          <h5 class="fw-bold">
                            {{ "LICENSESUMMARY.LICENSEHISTORY" | translate }}
                          </h5>
                          <div class="table-responsive">
                            <table class="table activity-table mb-0" aria-describedby="License summary">
                              <thead class="activity-header">
                                <tr>
                                  <th>{{ "LICENSESUMMARY.DATE" | translate }}</th>
                                  <th>
                                    {{ "LICENSESUMMARY.ACTIONTAKEN" | translate }}
                                  </th>
                                  <th>
                                    {{ "LICENSESUMMARY.HISTORYACTIVITY" | translate }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="text-capitalize bg-white" *ngFor="let item of licenseHistoryRecords">
                                  <td>
                                    {{
                                    item.date == null
                                    ? "N/A"
                                    : (item.date | translate)
                                    }}
                                  </td>
                                  <td>
                                    {{
                                    item.action == null
                                    ? "N/A"
                                    : (item.action | translate)
                                    }}
                                  </td>
                                  <td>
                                    <div [innerHTML]="
                                    item.activityActionMessage == null
                                      ? 'N/A'
                                      : item.activityActionMessage
                                  "></div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div> -->
                        </span>
                      </ng-container>
                      <ng-container *ngIf="selectedUserLicenseIndex && getUserIndexData">
                        <tab-content>
                          <span title1>{{ "LICENSESUMMARY.NAME" | translate }} :
                          </span>
                          <span desc1>{{
                            getUserIndexData?.name == null
                            ? "N/A"
                            : getUserIndexData?.name
                            }}</span>

                          <span title3>{{ "LICENSESUMMARY.EMAIL" | translate }} :
                          </span>
                          <span desc3>{{
                            getUserIndexData?.email == null
                            ? "N/A"
                            : getUserIndexData?.email
                            }}</span>
                          <span title2>{{ "LICENSESUMMARY.PRODUCTNAME" | translate }} :
                          </span>
                          <span desc2>{{
                            getUserIndexData?.phoneNumber == null
                            ? "N/A"
                            : getUserIndexData?.phoneNumber
                            }}</span>
                          <span title4>{{ "LICENSESUMMARY.PRODUCTKEY" | translate }} :
                          </span>
                          <span desc4>{{
                            getUserIndexData?.productKey == null
                            ? "N/A"
                            : getUserIndexData?.productKey
                            }}</span>
                          <span title5>{{ "LICENSESUMMARY.PRODUCTNAME" | translate }} :
                          </span>
                          <span desc5>{{
                            getUserIndexData?.productName == null
                            ? "N/A"
                            : getUserIndexData?.productName
                            }}</span>
                          <span title6>{{ "LICENSESUMMARY.BUILDVERSION" | translate }} :
                          </span>
                          <span desc6>{{
                            getUserIndexData?.buildVersion == null
                            ? "N/A"
                            : getUserIndexData?.buildVersion
                            }}</span>
                          <span title7>{{ "LICENSESUMMARY.LICENSEVALIDITY" | translate
                            }}<span *ngIf="
                          getUserIndexData?.productKeyType == 'FAMILY_PACK'
                        " [ngClass]="
                          getUserIndexData?.productKeyType == 'FAMILY_PACK'
                            ? 'mt-3'
                            : ''
                        ">
                              / {{ "LICENSESUMMARY.EXPIRYDATE" | translate }}</span>
                            :
                          </span>

                          <span desc7>{{
                            getUserIndexData?.licenseValidityDate == null
                            ? "N/A"
                            : getUserIndexData?.licenseValidityDate
                            }}</span>
                          <span title8>{{ "LICENSESUMMARY.ACTIVATIONDATE" | translate }} :
                          </span>
                          <span desc8>{{
                            getUserIndexData?.activationDate == null
                            ? "N/A"
                            : getUserIndexData?.activationDate
                            }}</span>

                          <span title9 *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                        getUserIndexData?.productKeyType == 'FAMILY_PACK'
                          ? 'mt-3'
                          : ''
                      ">{{ "LICENSESUMMARY.LICENSEOUNT" | translate }} :
                          </span>
                          <span desc9 *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                        getUserIndexData?.productKeyType == 'FAMILY_PACK'
                          ? 'mt-3'
                          : ''
                      ">{{
                            getUserIndexData?.totalLicenseCount == null
                            ? "N/A"
                            : getUserIndexData?.totalLicenseCount
                            }}
                            <span class="ms-2">
                              <span *ngFor="let item of totalNumberOfDevices">
                                <img [src]="'LICENSESUMMARY.KEYACTIVE'|translate" alt="" *ngIf="item.isSelected">
                                <img [src]="'LICENSESUMMARY.KEYINACTIVE'|translate" alt="" *ngIf="!item.isSelected">
                              </span>
                            </span>
                          </span>
                          <span btn2 *ngIf="
                        getUserIndexData?.licenseValidityDate !== 'Free version'
                      ">
                            <button [disabled]="getUserIndexData?.productLink == null"
                              [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button me-3' : 'q-form-white-submit cursor-pointer me-3' "
                              (click)="openMyIndexRenewLicense(getUserIndexData)">
                              {{ "LICENSESUMMARY.RENEW" | translate }}
                            </button>
                          </span>
                          <span btn2 *ngIf="
                        getUserIndexData?.licenseValidityDate === 'Free version'
                      ">
                            <button [disabled]="getUserIndexData?.productLink == null"
                              [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button me-3' : 'q-form-white-submit cursor-pointer me-3' "
                              (click)="openMyIndexRenewLicense(getUserIndexData)">
                              {{ "LICENSESUMMARY.BUYPREMIUM" | translate }}
                            </button>
                          </span>
                        </tab-content>
                        <span btn3>
                          <button class="q-form-white-submit" (click)="openRemoveLicensePopup(getUserIndexData.id)">
                            {{ "LICENSESUMMARY.REMOVELICENSE" | translate }}
                          </button></span>

                        <div *ngIf="getUserIndexData?.productKeyType == 'MOBILE'">

                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.NAME" | translate }} :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.name == null
                              ? "N/A"
                              : getUserIndexData?.name
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.EMAIL" | translate }} :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.email == null
                              ? "N/A"
                              : getUserIndexData?.email
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.PHONENO" | translate }} :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.phoneNumber == null
                              ? "N/A"
                              : getUserIndexData?.phoneNumber
                              }}
                            </div>
                          </div>


                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.PRODUCTNAME" | translate }} :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.productName == null
                              ? "N/A"
                              : getUserIndexData?.productName
                              }}
                            </div>
                          </div>
                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.PRODUCTKEY" | translate }} :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.productKey == null
                              ? "N/A"
                              : getUserIndexData?.productKey
                              }}
                            </div>
                          </div>
                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.BUILDVERSION" | translate }} :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.buildVersion == null
                              ? "N/A"
                              : getUserIndexData?.buildVersion
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.LICENSEVALIDITY" | translate
                              }}
                              <span *ngIf="
                        getUserIndexData?.productKeyType == 'FAMILY_PACK'
                      " [ngClass]="
                        getUserIndexData?.productKeyType == 'FAMILY_PACK'
                          ? 'mt-3'
                          : ''
                      ">
                                / {{ "LICENSESUMMARY.EXPIRYDATE" | translate }}</span>
                              :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.licenseValidityDate == null
                              ? "N/A"
                              : getUserIndexData?.licenseValidityDate
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.ACTIVATIONDATE" | translate }} :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.activationDate == null
                              ? "N/A"
                              : getUserIndexData?.activationDate
                              }}
                            </div>
                          </div>

                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              <span *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                      getUserIndexData?.productKeyType == 'FAMILY_PACK'
                        ? 'mt-3'
                        : ''
                    ">{{ "LICENSESUMMARY.LICENSEOUNT" | translate }} :
                              </span>
                            </div>
                            <div class="q-tab-content-desc">
                              <span *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                          getUserIndexData?.productKeyType == 'FAMILY_PACK'
                            ? 'mt-3'
                            : ''
                        ">{{
                                getUserIndexData?.totalLicenseCount == null
                                ? "N/A"
                                : getUserIndexData?.totalLicenseCount
                                }}

                                <span class="ms-2" *ngIf="totalNumberOfDevices?.length <= 30">
                                  <span *ngFor="let item of totalNumberOfDevices">
                                    <img [src]="'LICENSESUMMARY.KEYACTIVE'|translate" alt="" *ngIf="item.isSelected">
                                    <img [src]="'LICENSESUMMARY.KEYINACTIVE'|translate" alt="" *ngIf="!item.isSelected">
                                  </span>
                                </span>
                                <span class="ms-2" *ngIf="totalNumberOfDevices?.length > 30">
                                  <span *ngFor="let item of totalNumberOfDevices;let idx=index">
                                    <img [src]="'LICENSESUMMARY.KEYACTIVE'|translate" alt=""
                                      *ngIf="item.isSelected&&idx<30">
                                    <img [src]="'LICENSESUMMARY.KEYINACTIVE'|translate" alt=""
                                      *ngIf="!item.isSelected&&idx<30">
                                    <span *ngIf="idx==30">...</span>
                                  </span>
                                </span>
                              </span>
                            </div>
                          </div>

                          <div class="d-flex mt-4 mb-2">
                            <div class="q-tab-content-title">
                              <div *ngIf="
                      getUserIndexData?.licenseValidityDate !== 'Free version'
                    ">
                                <button [disabled]="getUserIndexData?.productLink == null"
                                  [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button me-3' : 'q-form-white-submit cursor-pointer me-3' "
                                  (click)="openMyIndexRenewLicense(getUserIndexData,'RENEW')">
                                  {{ "LICENSESUMMARY.RENEW" | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex mt-4 mb-3">
                            <div class="q-tab-content-title">
                              <div *ngIf="
                          getUserIndexData?.licenseValidityDate === 'Free version'
                        ">
                                <button [disabled]="getUserIndexData?.productLink == null"
                                  [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button me-3' : 'q-form-white-submit cursor-pointer me-3' "
                                  (click)="openMyIndexRenewLicense(getUserIndexData,'PREMIUM')">
                                  {{ "LICENSESUMMARY.BUYPREMIUM" | translate }}
                                </button>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div *ngIf="getUserIndexData?.productKeyType == 'SYSTEM'">
                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.PRODLICENSEDTO" | translate }} :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.name == null
                              ? "N/A"
                              : getUserIndexData?.name
                              }}
                            </div>
                          </div>
                          <div class="d-flex flex-wrap mt-3">
                            <div class="q-tab-content-title">
                              {{ "LICENSESUMMARY.LICENSEVALIDITY" | translate }}
                              <span *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                          getUserIndexData?.productKeyType == 'FAMILY_PACK'
                            ? 'mt-3'
                            : ''
                        ">
                                / {{ "LICENSESUMMARY.EXPIRYDATE" | translate }}
                              </span>
                              :
                            </div>
                            <div class="q-tab-content-desc">
                              {{
                              getUserIndexData?.licenseValidityDate == null
                              ? "N/A"
                              : getUserIndexData?.licenseValidityDate
                              }}
                            </div>
                          </div>
                        </div>

                        <div *ngIf="getUserIndexData?.productKeyType == 'SYSTEM' && licenseHistoryRecords?.length != 0"
                          class="my-4 mw-1000">
                          <hr />
                          <h5 class="fw-bold">
                            {{ "LICENSESUMMARY.LICENSEHISTORY" | translate }}
                          </h5>
                          <div class="table-responsive">
                            <table class="table activity-table mb-0" aria-describedby="License summary">
                              <thead class="activity-header">
                                <tr>
                                  <th>{{ "LICENSESUMMARY.DATE" | translate }}</th>
                                  <th>
                                    {{ "LICENSESUMMARY.ACTIONTAKEN" | translate }}
                                  </th>
                                  <th>
                                    {{ "LICENSESUMMARY.HISTORYACTIVITY" | translate }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="text-capitalize bg-white" *ngFor="let item of licenseHistoryRecords">
                                  <td>
                                    {{
                                    item.date == null
                                    ? "N/A"
                                    : (item.date | translate)
                                    }}
                                  </td>
                                  <td>
                                    {{
                                    item.action == null
                                    ? "N/A"
                                    : (item.action | translate)
                                    }}
                                  </td>
                                  <td>
                                    <div [innerHTML]="
                                  item.activityActionMessage == null
                                    ? 'N/A'
                                    : item.activityActionMessage
                                "></div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div
                          *ngIf="getUserIndexData.productKeyType === 'FAMILY_PACK' && licenseHistoryRecords?.length!=0"
                          class="my-4 w-1000">
                          <div class="table-responsive w-100">
                            <table class="table activity-table mb-0" aria-describedby="License summary">
                              <thead class="activity-header">
                                <tr>
                                  <th>{{ "LICENSESUMMARY.DEVICENAME" | translate }}</th>
                                  <th>
                                    {{ "LICENSESUMMARY.ACTIVATIONDATE" | translate }}
                                  </th>
                                  <th>{{ "LICENSESUMMARY.IMEINO" | translate }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="text-capitalize bg-white" *ngFor="let item of licenseHistoryRecords">
                                  <td>
                                    {{ item.deviceName | translate }}
                                  </td>
                                  <td>
                                    {{ getDate(item.activationDate) }}
                                  </td>
                                  <td>
                                    {{ item.installationNo }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-block d-md-none" *ngIf="getMyUseDeviceData?.length != 0">
            <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample2">
              <div *ngFor="let item of getMyUseDeviceData; let ind = index">
                <div>
                  <strong>{{ item.name }} ({{
                    item.myUserLicenseList?.length
                    }})</strong>
                </div>

                <div *ngFor="
                    let myUserDevice of item.myUserLicenseList;
                    let i = index
                  " class="accordion-item bg-white mb-3">
                  <div class="accordion-header mb-0" id="headingOne{{ ind+50 }}">
                    <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
                      data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ ind+50 }}" aria-expanded="false"
                      attr.aria-controls="collapseOne{{ ind+50 }}" (click)="selectedUserIndex(i, myUserDevice)">
                      <span class="me-4">
                        <tab-title-inline>
                          <span title1 data-toggle="tooltip" i18n-title title='{{myUserDevice?.deviceName == null
                        ? "N/A"
                        : myUserDevice?.deviceName}} ' *ngIf="
                          myUserDevice.productKeyType !== 'FAMILY_PACK'
                        ">
                            <span *ngIf="myUserDevice?.productKeyType == 'SYSTEM'" style="margin: -3px">
                              <img [src]="'MANAGEDEVICE.LAPTOPSM'|translate" class="me-2" alt="" srcset=""
                                height="18px" />
                            </span>
                            <span *ngIf="myUserDevice?.productKeyType == 'MOBILE'" style="margin: -3px">
                              <img [src]="'MANAGEDEVICE.MBLSM'|translate" class="me-2" alt="" srcset="" height="18px" />
                            </span> {{
                            myUserDevice?.deviceName == null
                            ? "N/A"
                            : myUserDevice?.deviceName
                            }}</span>
                          <span title1 data-toggle="tooltip" i18n-title
                            title='{{"LICENSESUMMARY.MULTIDEVICEKEY" | translate}}' *ngIf="
                          myUserDevice.productKeyType == 'FAMILY_PACK'
                        "><strong>{{
                              "LICENSESUMMARY.MULTIDEVICEKEY" | translate
                              }}</strong></span>
                          <span title2 data-toggle="tooltip" i18n-title title='{{myUserDevice?.productName == null
                        ? "N/A"
                        : myUserDevice?.productName}}'>{{
                            myUserDevice?.productName == null
                            ? "N/A"
                            : myUserDevice?.productName
                            }}</span>



                        </tab-title-inline>
                        <div class="mt-3">
                          <div data-toggle="tooltip" i18n-title title='{{
                                              "LICENSESUMMARY.MULTIDEVICEPACK" | translate
                                              }}' *ngIf="myUserDevice.productKeyType == 'FAMILY_PACK'">
                            <img [src]="'LICENSESUMMARY.MULTIDEVICEIMG'|translate" alt="" />
                            <small class="fw-normal ms-2">{{
                              "LICENSESUMMARY.MULTIDEVICEPACK" | translate
                              }}</small>
                          </div>
                          <p [ngClass]="selectedUserLicenseId == myUserDevice.id && activeUserTab == true ? 'expiry-text w-113':'expiry-text w-100' "
                            class="text-danger mb-0 text-xs text-center" *ngIf="myUserDevice.expiringStatus != null">
                            {{ "LICENSESUMMARY.EXPIRINGSOON" | translate }}
                          </p>
                          <p [ngClass]="selectedUserLicenseId == myUserDevice.id && activeUserTab == true ? 'expiry-text w-113':'expiry-text w-100' "
                            class="text-danger mb-0 text-xs text-center"
                            *ngIf="myUserDevice.expiringStatus === 'LICENSE_EXPIRED' ">
                            <strong>{{"MANAGEDEVICE.LICENSEEXP" | translate}}</strong>
                          </p>
                        </div>
                      </span>
                    </button>
                  </div>
                  <div id="collapse_{{ ind+50 }}" class="accordion-collapse collapse"
                    attr.aria-labelledby="headingOne{{ ind+50 }}" data-bs-parent="#accordionExample2">
                    <div class="accordion-body">
                      <tab-content>
                        <span title1>{{ "LICENSESUMMARY.NAME" | translate }} :
                        </span>
                        <span desc1>{{
                          getUserIndexData?.name == null
                          ? "N/A"
                          : getUserIndexData?.name
                          }}</span>

                        <span title3>{{ "LICENSESUMMARY.EMAIL" | translate }} :
                        </span>
                        <span desc3>{{
                          getUserIndexData?.email == null
                          ? "N/A"
                          : getUserIndexData?.email
                          }}</span>
                        <span title2>{{ "LICENSESUMMARY.PHONENO" | translate }} :
                        </span>
                        <span desc2>{{
                          getUserIndexData?.phoneNumber == null
                          ? "N/A"
                          : getUserIndexData?.phoneNumber
                          }}</span>
                        <span title4>{{ "LICENSESUMMARY.PRODUCTKEY" | translate }} :
                        </span>
                        <span desc4>{{
                          getUserIndexData?.productKey == null
                          ? "N/A"
                          : getUserIndexData?.productKey
                          }}</span>
                        <span title5>{{ "LICENSESUMMARY.PRODUCTNAME" | translate }} :
                        </span>
                        <span desc5>{{
                          getUserIndexData?.productName == null
                          ? "N/A"
                          : getUserIndexData?.productName
                          }}</span>

                        <span title6>{{ "LICENSESUMMARY.BUILDVERSION" | translate }} :
                        </span>
                        <span desc6>{{
                          getUserIndexData?.buildVersion == null
                          ? "N/A"
                          : getUserIndexData?.buildVersion
                          }}</span>
                        <span title7>{{ "LICENSESUMMARY.LICENSEVALIDITY" | translate
                          }}<span *ngIf="
                          getUserIndexData?.productKeyType == 'FAMILY_PACK'
                        " [ngClass]="
                          getUserIndexData?.productKeyType == 'FAMILY_PACK'
                            ? 'mt-3'
                            : ''
                        ">
                            / {{ "LICENSESUMMARY.EXPIRYDATE" | translate }}</span>
                          :
                        </span>

                        <span desc7>{{
                          getUserIndexData?.licenseValidityDate == null
                          ? "N/A"
                          : getUserIndexData?.licenseValidityDate
                          }}</span>
                        <span title8>{{ "LICENSESUMMARY.ACTIVATIONDATE" | translate }} :
                        </span>
                        <span desc8>{{
                          getUserIndexData?.activationDate == null
                          ? "N/A"
                          : getUserIndexData?.activationDate
                          }}</span>

                        <span title9 *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                        getUserIndexData?.productKeyType == 'FAMILY_PACK'
                          ? 'mt-3'
                          : ''
                      ">{{ "LICENSESUMMARY.LICENSEOUNT" | translate }} :
                        </span>
                        <span desc9 *ngIf="getUserIndexData?.productKeyType == 'FAMILY_PACK'" [ngClass]="
                        getUserIndexData?.productKeyType == 'FAMILY_PACK'
                          ? 'mt-3'
                          : ''
                      ">{{
                          getUserIndexData?.totalLicenseCount == null
                          ? "N/A"
                          : getUserIndexData?.totalLicenseCount
                          }}

                          <span class="ms-2" *ngIf="totalNumberOfDevices?.length <= 30">
                            <span *ngFor="let item of totalNumberOfDevices">
                              <img [src]="'LICENSESUMMARY.KEYACTIVE'|translate" alt="" *ngIf="item.isSelected">
                              <img [src]="'LICENSESUMMARY.KEYINACTIVE'|translate" alt="" *ngIf="!item.isSelected">
                            </span>
                          </span>
                          <span class="ms-2" *ngIf="totalNumberOfDevices?.length > 30">
                            <span *ngFor="let item of totalNumberOfDevices;let idx=index">
                              <img [src]="'LICENSESUMMARY.KEYACTIVE'|translate" alt="" *ngIf="item.isSelected&&idx<30">
                              <img [src]="'LICENSESUMMARY.KEYINACTIVE'|translate" alt=""
                                *ngIf="!item.isSelected&&idx<30">
                              <span *ngIf="idx==30">...</span>
                            </span>
                          </span>
                        </span>
                        <div btn2 *ngIf="
                        getUserIndexData?.licenseValidityDate !== 'Free version'
                      ">
                          <button [disabled]="getUserIndexData?.productLink == null"
                            [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button me-3' : 'q-form-white-submit cursor-pointer me-3' "
                            (click)="openMyIndexRenewLicense(getUserIndexData,'RENEW')">
                            {{ "LICENSESUMMARY.RENEW" | translate }}
                          </button>
                        </div>
                        <div btn2 *ngIf="
                        getUserIndexData?.licenseValidityDate === 'Free version'
                      ">
                          <button [disabled]="getUserIndexData?.productLink == null"
                            [ngClass]="getUserIndexData?.productLink == null ? 'q-invalid-button me-3' : 'q-form-white-submit cursor-pointer me-3' "
                            (click)="openMyIndexRenewLicense(getUserIndexData,'PREMIUM')">
                            {{ "LICENSESUMMARY.BUYPREMIUM" | translate }}
                          </button>
                        </div>
                      </tab-content>

                      <span title9>
                        <div *ngIf="
                        getUserIndexData.productKeyType === 'FAMILY_PACK' &&
                        licenseHistoryRecords?.length != 0
                      " class="my-4 mw-1000">
                          <div class="table-responsive">
                            <table class="table activity-table mb-0" aria-describedby="License summary">
                              <thead class="activity-header">
                                <tr>
                                  <th>
                                    {{ "LICENSESUMMARY.DEVICENAME" | translate }}
                                  </th>
                                  <th>
                                    {{ "LICENSESUMMARY.ACTIVATIONDATE" | translate }}
                                  </th>
                                  <th>{{ "LICENSESUMMARY.IMEINO" | translate }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="text-capitalize bg-white" *ngFor="let item of licenseHistoryRecords">
                                  <td>
                                    {{ item.deviceName | translate }}
                                  </td>
                                  <td>
                                    {{ getDate(item.activationDate) }}
                                  </td>
                                  <td>
                                    {{ item.installationNo }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div *ngIf="
                        getUserIndexData?.productKeyType == 'SYSTEM' &&
                        licenseHistoryRecords?.length != 0
                      " class="my-4 mw-1000">
                          <hr />
                          <h5 class="fw-bold">
                            {{ "LICENSESUMMARY.LICENSEHISTORY" | translate }}
                          </h5>
                          <div class="table-responsive">
                            <table class="table activity-table mb-0" aria-describedby="License summary">
                              <thead class="activity-header">
                                <tr>
                                  <th>{{ "LICENSESUMMARY.DATE" | translate }}</th>
                                  <th>
                                    {{ "LICENSESUMMARY.ACTIONTAKEN" | translate }}
                                  </th>
                                  <th>
                                    {{ "LICENSESUMMARY.HISTORYACTIVITY" | translate }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="text-capitalize bg-white" *ngFor="let item of licenseHistoryRecords">
                                  <td>
                                    {{
                                    item.date == null
                                    ? "N/A"
                                    : (item.date | translate)
                                    }}
                                  </td>
                                  <td>
                                    {{
                                    item.action == null
                                    ? "N/A"
                                    : (item.action | translate)
                                    }}
                                  </td>
                                  <td>
                                    <div [innerHTML]="
                                    item.activityActionMessage == null
                                      ? 'N/A'
                                      : item.activityActionMessage
                                  "></div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="removeLicensePopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="forgotpwd">
    <ng-container *ngIf="!isDeviceRemoved">
      <div class="modal-content rounded-25">
        <!-- Modal Header -->
        <div class="text-center">
          <div class="my-3">
            <img [src]="'IMAGES.DELETEIMG'|translate" alt="" class="mx-auto" />
          </div>
          <h4 class="mb-2 fw-bold">
            {{ "SUCESSMESSAGE.REMOVELICENSE" | translate }}
          </h4>
          <p class="mb-0">
            {{ "LICENSESUMMARY.PRODUCTKEY" | translate }} :
            <span class="fw-bold">
              {{ getMyIndexData?.productKey }}
            </span>
          </p>
        </div>
        <!-- Modal body -->

        <div class="form-div mt-3 mb-4 d-flex">
          <button (click)="onRemoveDevice()" class="submit-btn bg-orgclr me-3">
            {{ "SUCESSMESSAGE.YES" | translate }}
          </button>
          <button class="cancel-btn bg-cancelbtn" data-bs-dismiss="modal">
            {{ "SUCESSMESSAGE.NO" | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isDeviceRemoved">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-3">
            <div>
              <img [src]="'SIGNUP.SUCCESSIMG'|translate" alt="" class="mx-auto" />
            </div>
            <h5 class="q-modal-heading fw-bold my-4">
              {{ "SUCESSMESSAGE.DEVICEREMOVEDSUCCESSFULLY" | translate }}
            </h5>
            <button class="submit-btn bg-orgclr w-auto" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="modal" id="renewPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered ">
    <ng-container>
      <div
        class="modal-content text-center border-none changeWidthHeight rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
        <div class="mt-3">
          <img src="./assets/images/not secure.png" alt="" class="mx-auto" />
        </div>
        <h5 class="fw-bold mt-1 mb-2">
          {{ "LICENSESUMMARY.RENEWPOPUP" | translate }}
        </h5>
        <p class="text-sm p-xl-2">
          {{ "LICENSESUMMARY.RENEWDESC" | translate }}

        </p>

        <div class="text-center mb-4 mt-1 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" data-bs-dismiss="modal">
              {{ "LICENSESUMMARY.OK" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>